<template>
    <div class="vantagens">
        <div class="content">
            <h2>Vantagens em adiantar recebíveis</h2>
            <p>Antecipe recebíveis sem burocracia e obtenha capital de giro para a sua empresa.</p>
            <div class="benefits">
                <div v-for="(item, index) in benefits" :key="index">
                    <i :class="item.class" class="icon"></i>
                    <h3>{{ item.title }}</h3>
                    <p>{{ item.text }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Benefits',
    data() {
        return {
            benefits: [
                {
                    class: 'fas fa-piggy-bank',
                    title: 'Facilidade',
                    text:
                        'Organização do fluxo de caixa recebendo o dinheiro à vista, assim fica mais fácil administrar sua empresa.'
                },
                {
                    class: 'fas fa-shield-alt',
                    title: 'Segurança',
                    text:
                        'Menor risco para sua empresa e sem surpresas. Cada passo é feito com transparência e segurança.'
                },
                {
                    class: 'fas fa-tachometer-alt',
                    title: 'Agilidade',
                    text:
                        'Liberação rápida e 100% digital, sem aquela burocracia bancária de filas ou visitas presenciais.'
                },
                {
                    class: 'fas fa-sync-alt',
                    title: 'Flexibilidade',
                    text:
                        'Taxas super competitivas! Buscamos ajudar inclusive empresas com dificuldades de obter crédito.'
                }
            ]
        };
    }
};
</script>

<style lang="scss" scoped>
.vantagens {
    background: #fff;
    text-align: center;
    padding: 72px 16px;
    @media screen and (max-width: 800px) {
        padding: 36px 16px;
    }
    .content {
        max-width: 1120px;
        width: 100%;
        margin: 0 auto;
        h2 {
            color: #0e3d74;
            font-family: 'Open Sans', sans-serif;
            font-size: 30px;
            line-height: 40px;
            margin: 0;
            font-weight: 700;
            margin-bottom: 15px;
        }
        p {
            font-size: 18px;
        }
        .benefits {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 30px;
            padding-top: 36px;
            @media screen and (max-width: 800px) {
                grid-template-columns: repeat(2, 1fr);      
            }
            @media screen and (max-width: 580px) {
                grid-template-columns: repeat(1, 1fr);      
            }
            .icon {
                color: #007bff;
                font-size: 50px;
            }
            h3 {
                color: #000;
                font-family: 'Open Sans', sans-serif;
                font-size: 26px;
                line-height: 30px;
                font-weight: 700;
            }
            p {
                font-size: 16px;
            }
        }
    }
}
</style>
